// -- == //
// import TicketMenuManagementCreate from "./lib/create";
import { useNavigate } from 'react-router';
import NewsTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import SecundButton from 'components/form/buttons/secundButton';
// import AppLoading from "components/appLoading";

import * as S from './styles';

export default function NewsPage() {
  const navigate = useNavigate();
  const { news } = useTypedSelector((state: any) => state.News);

  const handleRedirect = () => {
    navigate('/panel/news/create');
  };

  return (
    <S.Container>
      <S.Head>
        <S.Title>News</S.Title>
        <SecundButton hasIcon={true} onClick={handleRedirect}>
          Create new News
        </SecundButton>
      </S.Head>
      <Gap size="20px" />
      <NewsTable data={news.data} loading={news.loading} />

      {/* <AppLoading loading={} /> */}
    </S.Container>
  );
}
